import { Box, Button, Grid, Stack, TextField, Typography } from "@mui/material";
import { useFormik } from "formik";
import React from "react";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import IMG_LOGO from "../../imgs/img-logo-nueva.jpeg";
import { collection, getDocs, query, where } from "firebase/firestore";
import { setUser } from "../../Utils/authSession";
import { dbFirebase } from "../../Conections/Firebase";
import bcrypt from "bcryptjs"; //

const LoginAuth = () => {
  const navigation = useNavigate();

  const validationSchema = yup.object({
    user: yup.string().required("El usuario es requerido"),
    password: yup.string().required("La contraseña es requerida"),
  });

  const formik = useFormik({
    initialValues: {
      user: "",
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        const q = query(
          collection(dbFirebase, "deudores"),
          where("user", "==", values.user)
        );

        const snapshot = await getDocs(q);

        if (!snapshot.empty) {
          const doc = snapshot.docs[0];
          const userData = { id: doc.id, ...doc.data() };

          // Verifica la contraseña encriptada con bcrypt
          const match = await bcrypt.compare(
            values.password,
            userData.password
          );

          if (match) {
            setUser(userData);
            
            setTimeout(() => {
              navigation("/dashboard");
            }, 800);
          } else {
            Swal.fire({
              title: "Acceso denegado",
              text: "Contraseña incorrecta",
              icon: "error",
              confirmButtonText: "Intentar de nuevo",
            });
          }
        } else {
          Swal.fire({
            title: "Acceso denegado",
            text: "Usuario no encontrado",
            icon: "error",
            confirmButtonText: "Intentar de nuevo",
          });
        }
      } catch (error) {
        console.error("Error al consultar Firestore:", error);
        Swal.fire("Error", "No se pudo iniciar sesión", "error");
      }
    },
  });

  return (
    <Grid container justifyContent="center">
      <Grid
        item
        xs={10}
        md={4}
        sx={{
          margin: "20px",
          border: "1px solid #ccc",
          borderRadius: "5px",
          padding: "15px",
          background: "rgba(205, 205, 192, 0.2)",
        }}
      >
        <Grid container spacing={2} alignItems="center" justifyContent="center">
          <Grid item xs={12}>
            <Stack alignItems="center" spacing={1} sx={{ margin: "20px" }}>
              <Typography
                variant="h4"
                sx={{ textAlign: "center", color: "rgb(0, 122, 255)" }}
              >
                Bienvenido a AppInvest
              </Typography>
              <Box sx={{ textAlign: "center" }}>
                <img alt="Logo" src={IMG_LOGO} width={200} />
              </Box>
            </Stack>
          </Grid>

          <Grid item xs={12}>
            <form onSubmit={formik.handleSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="user"
                    name="user"
                    label="Usuario"
                    value={formik.values.user}
                    onChange={formik.handleChange}
                    error={formik.touched.user && Boolean(formik.errors.user)}
                    helperText={formik.touched.user && formik.errors.user}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    id="password"
                    name="password"
                    type="password"
                    label="Contraseña"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    error={
                      formik.touched.password && Boolean(formik.errors.password)
                    }
                    helperText={
                      formik.touched.password && formik.errors.password
                    }
                  />
                </Grid>
              </Grid>

              <Button
                color="primary"
                variant="contained"
                sx={{ marginTop: "20px" }}
                type="submit"
                fullWidth
              >
                Entrar
              </Button>
            </form>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default LoginAuth;
